import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  addLoading: false,
  dashboard: null,
  alerts: [],
  alertsCount: 0,
  staffOverview: [],
  staffOverviewCount: 0,
  facilityOverview: [],
  facilityOverviewCount: 0,
  clientOverview: [],
  clientOverviewCount: 0,
  clientDocOverview: [],
  clientDocOverviewCount: 0,
  credentialTypes: [],
  clientItems: [],
  facilityItems: [],
  staffCredentials: [],
  clientRecords: [],
  facilityRecords: [],
  settings: null,
  documentTemplates: null,
  operationalTasks: [],
  operationalTasksCount: 0,
  operationalTasksLoading: false,
};

export const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    setLoading(state, action) {
      return { ...state, loading: action?.payload };
    },
    setAddLoading(state, action) {
      return { ...state, addLoading: action?.payload };
    },
    setDashboard(state, action) {
      return { ...state, loading: false, dashboard: action?.payload };
    },
    setAlerts(state, action) {
      return { ...state, alerts: action?.payload };
    },
    setAlertsCount(state, action) {
      return { ...state, alertsCount: action?.payload };
    },
    setStaffOverview(state, action) {
      return { ...state, loading: false, staffOverview: action?.payload };
    },
    setStaffOverviewCount(state, action) {
      return { ...state, staffOverviewCount: action?.payload };
    },
    setFacilityOverview(state, action) {
      return { ...state, loading: false, facilityOverview: action?.payload };
    },
    setFacilityOverviewCount(state, action) {
      return { ...state, facilityOverviewCount: action?.payload };
    },
    setClientOverview(state, action) {
      return { ...state, loading: false, clientOverview: action?.payload };
    },
    setClientOverviewCount(state, action) {
      return { ...state, clientOverviewCount: action?.payload };
    },
    setClientDocOverview(state, action) {
      return { ...state, loading: false, clientDocOverview: action?.payload };
    },
    setClientDocOverviewCount(state, action) {
      return { ...state, clientDocOverviewCount: action?.payload };
    },
    setCredentialTypes(state, action) {
      return { ...state, credentialTypes: action?.payload };
    },
    setClientItems(state, action) {
      return { ...state, clientItems: action?.payload };
    },
    setFacilityItems(state, action) {
      return { ...state, facilityItems: action?.payload };
    },
    setStaffCredentials(state, action) {
      return { ...state, staffCredentials: action?.payload };
    },
    setClientRecords(state, action) {
      return { ...state, clientRecords: action?.payload };
    },
    setFacilityRecords(state, action) {
      return { ...state, facilityRecords: action?.payload };
    },
    setSettings(state, action) {
      return { ...state, settings: action?.payload };
    },
    setDocumentTemplates(state, action) {
      return { ...state, documentTemplates: action?.payload };
    },
    setOperationalTasks(state, action) {
      return { ...state, operationalTasks: action?.payload };
    },
    setOperationalTasksCount(state, action) {
      return { ...state, operationalTasksCount: action?.payload };
    },
    setOperationalTasksLoading(state, action) {
      return { ...state, operationalTasksLoading: action?.payload };
    },
    patchClientItem(state, action) {
      const updated = action.payload;
      const id = updated._id || updated.id;
      return {
        ...state,
        clientItems: state.clientItems.map((item) =>
          (item._id || item.id) === id ? { ...item, ...updated } : item
        ),
      };
    },
    patchFacilityItem(state, action) {
      const updated = action.payload;
      const id = updated._id || updated.id;
      return {
        ...state,
        facilityItems: state.facilityItems.map((item) =>
          (item._id || item.id) === id ? { ...item, ...updated } : item
        ),
      };
    },
    reset() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setAddLoading,
  setDashboard,
  setAlerts,
  setAlertsCount,
  setStaffOverview,
  setStaffOverviewCount,
  setFacilityOverview,
  setFacilityOverviewCount,
  setClientOverview,
  setClientOverviewCount,
  setClientDocOverview,
  setClientDocOverviewCount,
  setCredentialTypes,
  setClientItems,
  setFacilityItems,
  setStaffCredentials,
  setClientRecords,
  setFacilityRecords,
  setSettings,
  setDocumentTemplates,
  setOperationalTasks,
  setOperationalTasksCount,
  setOperationalTasksLoading,
  patchClientItem,
  patchFacilityItem,
  reset,
} = complianceSlice.actions;

export default complianceSlice.reducer;
